import React from 'react';
import {Link} from 'react-router';
import UserAvatar from 'components/pure/utils/UserAvatar';
import AuthStore from 'stores/AuthStore';
import './CoachSummaryDashboard.styl';
import ManagerCoachingEffectiveness from 'components/dashboard/manager/ManagerCoachingEffectiveness';
import DashboardV2LoadingOverlay from 'components/manager-dashboard/DashboardV2LoadingOverlay';
import ManagerCoachingPageContainer from 'components/coaching/landing-pages/ManagerCoachingPageContainer';
import ManagerCTA from 'components/dashboard/ManagerCTA';
import buildUrl from 'components/dashboard/buildUrl';
import {RepCoachingPlansContainer} from 'components/dashboard/rep/RepProfilePageContainer';
import UpcomingReviewsStore from 'stores/coaching/UpcomingReviewsStore';
import AccountStore from 'stores/AccountStore';
import moment from 'moment';
import {List} from 'immutable';
import connectToStores from 'alt-utils/lib/connectToStores';
import AccountActions from 'actions/AccountActions';
import ManagerNewAccount from 'components/dashboard/manager/ManagerNewAccount';
import CoachingQuickReminders from 'components/dashboard/CoachingQuickReminders';
import {HISTORY_ACTIONS} from 'components/StatsPage2.utils';
import {CTARole} from 'components/dashboard/ManagerCTA.utils';

const SUMMARY_LIMIT = 4;

export function getCoachRepLink(
  repObj,
  props,
  linkObj,
  pushDashHistory,
  page = null,
  // use this if the props does not have a managerId (and shouldn't)
  managerId
) {
  const link = linkObj || {};
  const repIsCoach = repObj.rep && repObj.rep.is_coach;
  if (repIsCoach) {
    // Coaches have a special dashboard so don't send them to reps
    const urlProps = {
      adminId: props.adminId,
      managerId: props.managerId,
      coachId: repObj.rep.id,
    };
    link.pathname = buildUrl(urlProps) + (page ? `/${page}` : '');
  } else {
    link.pathname = '/metrics/profile';
    link.query = {
      ...link.query,
      userId: repObj.rep ? repObj.rep.id : repObj.repId,
      teamId: repObj.rep ? repObj.rep.teamId : repObj.teamId,
    };

    const manId = managerId ? managerId : props.managerId;
    if (manId) {
      link.query.managerId = manId;
    }
  }

  return pushDashHistory ? pushToHistory(link, props) : link;
}

function pushToHistory(link, props) {
  const fromPath = props.fromPath
    ? props.fromPath
    : props.location && props.location.pathname
    ? props.location.pathname
    : null;
  link.state = {
    ...link.state,
    action: HISTORY_ACTIONS.PUSH,
    pathname: fromPath,
  };

  return link;
}

@connectToStores
export default class CoachSummaryDashboard extends React.Component {
  static getStores() {
    return [UpcomingReviewsStore, AccountStore];
  }

  static getPropsFromStores({managerId}) {
    const accountStore = AccountStore.getState();
    const twoWeeksAgo = moment().subtract(2, 'weeks');
    const recentlyMade = twoWeeksAgo.isBefore(accountStore.createdDate);
    const reviews = UpcomingReviewsStore.getState().upcomingReviewsMap.get(managerId, List());
    return {
      isNewAccount: recentlyMade && reviews.isEmpty(),
      createdDateLoading: accountStore.createdDateLoading,
      createdDateFetched: accountStore.createdDateFetched,
    };
  }

  componentDidMount() {
    !this.props.createdDateFetched && AccountActions.fetchCreatedDate();
  }

  render() {
    const {location, coach: coachToDisplay, coachId, isNewAccount} = this.props;
    const authUser = AuthStore.getState().user;
    const ownSummary = authUser.id === (coachToDisplay && coachToDisplay.id);
    return (
      <div className="coach-summary-dashboard">
        <DashboardV2LoadingOverlay />
        <div className="top-row">
          {coachToDisplay && (
            <div className="coach-profile">
              <UserAvatar user={coachToDisplay} />
              <div className="coach-details">
                <div className="coach-name">
                  <span style={{WebkitBoxOrient: 'vertical'}}>{coachToDisplay.firstName}</span>
                  <span style={{WebkitBoxOrient: 'vertical'}}>{coachToDisplay.lastName}</span>
                </div>
                {ownSummary && (
                  <Link className="generic-link coach-profile-link" to={'/admin/profile'}>
                    Edit Profile
                  </Link>
                )}
              </div>
            </div>
          )}
          {ownSummary ? (
            <div className="ctas-container">
              <ManagerCTA {...this.props} role={CTARole.COACH} />
            </div>
          ) : (
            <div />
          )}
        </div>
        {ownSummary && isNewAccount && <ManagerNewAccount />}
        {coachToDisplay && !isNewAccount && <CoachingQuickReminders location={location} />}
        {coachToDisplay && !isNewAccount && (
          <ManagerCoachingEffectiveness
            {...this.props}
            viewForCoach
            dataForCoach
            managerId={coachId}
            rows={SUMMARY_LIMIT}
            showMoreLink={location.pathname.replace('summary', 'coaching-effectiveness')}
          />
        )}
        {!isNewAccount && (
          <div className="standalone-widget-wrapper team-rankings-container">
            <ManagerCoachingPageContainer
              {...this.props}
              showMoreLink={location.pathname.replace('summary', 'coaching-plans')}
              usePropsManagerId
              forCoach
              isSummary
              suppressToggle
              plansLimit={SUMMARY_LIMIT}
            />
          </div>
        )}
        {!isNewAccount && (
          <RepCoachingPlansContainer
            {...this.props}
            isSummary
            showMoreLink={location.pathname.replace('summary', 'coaching-plans-for-you')}
            plansLimit={SUMMARY_LIMIT}
          />
        )}
      </div>
    );
  }
}
